<template>
    <v-row no-gutters class="fill-height">
        <v-col cols="12" align="center" class="mt-4">
            <div class="text-h6">Is Homepage icons are not visible, please click on "Reload Application" button.
                <v-btn color="primary" class="ml-2" @click="reloadApp">Reload Application</v-btn>
            </div>
            <v-col cols="12" class="mt-2 pa-0" >
                Login Email: lawlibrarykiosktest@arsconnect.com | Password: backspace
            </v-col>
        </v-col>
        <v-col cols="12" align="center">
            <v-container class="iframe-wrapper">
                <div class="iframe-container">
                    <iframe allow="camera; microphone" id="kioskApp" src="https://elpaso-kiosk-stage.netlify.app"
                        frameborder="1px"></iframe>
                    <span>{{ innWidth }}</span>
                </div>
            </v-container>
        </v-col>

    </v-row>
</template>
<script>
export default {
    name: 'kioskSimulator',
    data: () => ({}),
    methods: {
        reloadApp() {
            var iframe = document.getElementById("kioskApp")
            var src = iframe.src;
            iframe.src = src;
        }
    },
    mounted() { },
    computed: {},
}
</script>

<style scoped>
.iframe-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 87vh;
    /* Full height of the viewport */
    overflow: hidden;
}

.iframe-container iframe {
    width: 1920px;
    height: 1080px;
    transform: scale(0.6);
    margin: 2px;
    border: none;
    /* Optional: removes the default border around the iframe */
}

@media screen and (max-width: 2600px) {
    .iframe-container iframe {
        transform: scale(0.8);
    }
}

@media screen and (max-width: 2000px) {
    .iframe-container iframe {
        transform: scale(0.7);
    }
}

/* For 14" MacBook screens (or similar) */
@media screen and (max-width: 1600px) {
    .iframe-container iframe {
        transform: scale(0.6);
    }
}
</style>